export const WalletBalance = () => {
    return (
        <div style={{ marginTop: 9 }}>
            <div style={{ fontSize: 14 }}>
                2.129045 USDT
            </div>
            <div style={{ fontSize: 10 }}>
                Wallet Balance
            </div>
        </div>
    )
}